export default __webpack_public_path__ + "static/media/deauville21.e4bb8512.jpg";